import React, { Suspense } from "react";
import { PublicKanbanSwitch } from "@rankmi/ats-app";

const PublicKanban = ({
  selectionProcessId,
}) => {
  
  return (
    <PublicKanbanSwitch
      selectionProcessId={selectionProcessId}
    />
  );
}

export default PublicKanban;